import axios from "axios";
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const staffApi = axios.create({ baseURL: BASE });
staffApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("staff_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export const staffErr = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
